module.exports = __webpack_public_path__ + "static/media/control-rojo.a73e5378.svg";